import React from "react";
import { createRoot } from 'react-dom/client';
import App from './components/App/App';
import TagManager from "react-gtm-module";
import './i18n';
import { configureAmplifyClient } from "./common/login/amplify-config";
import AuthGate from "./common/login/AuthGate";

const tagManagerArgs = {
  gtmId: "GTM-PNKPG57K", 
};

TagManager.initialize(tagManagerArgs);

const host = typeof window !== "undefined" ? window.location.hostname : "";
const isDevDomain = /(^|\.)dev\.backendhelpers\.co$/.test(host);

const ENABLE_AUTH_GUARD = isDevDomain;

function hideBootSplash() {
  const el = document.getElementById("boot-splash");
  if (el) el.style.display = "none";
}

if (ENABLE_AUTH_GUARD) configureAmplifyClient();

const root = createRoot(document.getElementById('root'));

const appTree = ENABLE_AUTH_GUARD ? (
  <AuthGate><App /></AuthGate>
) : (
  <App />
);

root.render(appTree);

// 👇 In production (without AuthGate), hide splash immediately
if (!ENABLE_AUTH_GUARD) hideBootSplash();